import { PageBreadcrumb } from '@/components/ui/PageBreadcrumb'
import { SubscribeCta } from '@/components/website/SubscribeCta'
import { AppointmentForm } from '@/components/website/AppointmentForm'

export function Appointment() {
  return (
    <>
      <PageBreadcrumb title="Appointment" hideContent compact />

      {/* appointment section start */}
      <section className="appointment-section-4 pt-100 md-pt-80 pb-100 md-pb-80">
        <div className="container">
          <div className="row flex-lg-row-reverse justify-content-between align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="appointment-content wow fadeInLeft" data-wow-delay=".2s">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="section-title">
                      <span className="sub-title">Appointment</span>
                      <h2>Book An Appointment</h2>
                    </div>
                  </div>
                </div>

                <div className="default-form appointment-form">
                  <AppointmentForm idPrefix="appt" />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              {/* appointment image start */}
              <div className="appointment-image wow fadeInRight" data-wow-delay=".2s">
                <div className="shape-1">
                  <img src="/assets/images/shape/shape-1.png" alt="shape" />
                </div>
                <div className="img1">
                  <figure>
                    <img
                      className="appointment-large"
                      src="/assets/images/appointment/appointment-4-1.jpg"
                      alt="appointment large"
                    />
                  </figure>
                </div>
                <div className="img2">
                  <figure>
                    <img
                      className="appointment-small"
                      src="/assets/images/appointment/appointment-4-2.jpg"
                      alt="appointment small"
                    />
                  </figure>
                </div>
              </div>
              {/* appointment image end */}
            </div>
          </div>
        </div>
      </section>
      {/* appointment section end */}

      <SubscribeCta />
    </>
  )
}
